export default "__VITE_ASSET__RR_IDW7R__"